import { useQuery } from '@tanstack/react-query';
import { authService } from '@services';

export const USER_PROFILE_QUERY_KEY = ['user', 'profile'] as const;

export const useUserProfile = () => {
  return useQuery({
    queryKey: USER_PROFILE_QUERY_KEY,
    queryFn: () => authService.getUserProfile(),
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 10,
  });
};
